<template>
    <div class="coupon-item" :class="{get: status == 2}">
        <div class="left-box">
            <div class="money-box">
                <template v-if="data.type == 0">
                    ¥<span class="num">{{data.value}}</span>
                </template>
                <template v-if="data.type == 1">
                    <span class="num">{{data.discount}}</span>折
                </template>
                
            </div>
            <div class="inof-box">
                <div class="box">
                    <div class="text-item type-rule-box">
                        <span class="type">{{data.isCouponThreshold === 1? '无门槛':`满${data.fullMinus}可用`}}</span>
                        <span class="rule" v-if="data.useExplain && status == 1" @click="handleRule(data.useExplain)">使用规则</span>
                    </div>
                    <div class="text-item time" v-if="status === 1">有效期：{{data.useEndTime}}</div>
                    <div v-if="data.branchName" class="text-item name van-ellipsis">{{data.branchName}}</div>
                </div>
            </div>
            
        </div>
        <div class="right-box">
            <span v-if="status === 1" class="use-text" @click="handleUse(data)">马上使用</span>
            <span v-else class="get-text" @click="handleGet(data.ucode)">立即领取</span>
        </div>
        <van-dialog v-model="show" title="使用规则" class="coupon-rules-btn" theme="round-button" :show-confirm-button="false" show-cancel-button cancel-button-text="知道了" cancel-button-color="#1F94FF">
            {{this.message}}
        </van-dialog>
    </div>
</template>
<script>
import { Dialog } from 'vant';

export default {
    props: {
        status: {
            type: Number,
            default: 1,
        },
        data:{
            type: Object,
            default: ()=>{}
        }
    },
    data(){
        return{
            message:'',
            show:false,
        }
    },
    mounted(){
    },
    methods: {
        handleUse(data) {
            this.$emit('useCoupon', data)
        },
        handleGet(ucode) {
            this.$emit('getCoupon', ucode)
        },
        handleRule(message) {
            this.message = message;
            this.show = true;
            //  Dialog.alert({
            //     title: '使用规则', 
            //     message,
            //     confirmButtonText: '知道了',
            //     confirmButtonColor:'#1F94FF',
            //     className: 'coupon-rules-btn',
            //     theme: 'round-button',
            // })
        }
    },
}
</script>
<style lang="less" scoped>
.coupon-rules-btn{
    /deep/.van-dialog__content{
        padding: 8px 24px 16px;
        text-align: left;
    }
    /deep/.van-dialog__footer{
        width: 100%;
        box-sizing: border-box;
    }
}
    .coupon-item {
        display: flex;
        align-items: center;
        margin-bottom: 24px;
        &.get {
            .left-box{
                &::before {
                    background-color: #FF6E1F;
                }
            }
            .right-box {
                background-color: #FF6E1F;
            }
        }
        .left-box {
            position: relative;
            flex: 1;
            height: 160px;
            background: linear-gradient(159deg, #FDEEDC 0%, #FEDBB1 100%);
            border-radius: 14px;
            display: flex;
            padding: 23px 0;
            box-sizing: border-box;
            &::after,&::before {
                content: '';
                width: 40px;
                height: 40px;
                border-radius: 50%;
                background-color: #fff;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
            }
            &::after {
                left: -25px;
            }
            &::before {
                right: -25px;
                background-color: #FE5746;
            }
            .money-box {
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 32px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                width: 222px;
                border-right: 1px dashed #C4986D;
                color: #FE5746;
                .num {
                    font-size: 64px;
                    font-family: AvenirNext-Bold, AvenirNext;
                    font-weight: bold;
                }
            }
            .inof-box {
                padding: 0 18px 0 24px;
                flex: 1;
                width: 337px;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                .text-item{
                    &:last-of-type {
                        margin-bottom: 0;
                    }
                }
                .type-rule-box {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    height: 37px;
                    margin-bottom: 6px;
                }
                .rule {
                    font-size: 20px;
                    font-weight: 400;
                    color: #9B663D;
                    line-height: 28px;
                    margin-top: 6px;
                }
                .type {
                    color: #FE5746;
                    font-size: 26px;
                    line-height: 37px;
                    
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                }
                .time,.name {
                    font-size: 20px;
                    color: #9B663D;
                    line-height: 28px;
                    margin-bottom: 12px;
                }
                .name {
                    margin-bottom: 0;
                }
            }

        }
        .right-box {
            width: 123px;
            height: 140px;
            border-radius:0 8px 8px 0;
            background-color: #FE5746;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            span {
                width: 60px;
                font-size: 28px;
                line-height: 40px;
            }
        }
    }
</style>